import GLightbox from 'glightbox/src/js/glightbox';

function initLightbox() {
    const lightbox = GLightbox({
        selector: '.lightbox',
        touchNavigation: true,
        loop: true,
    });

    document.querySelector('.js-trigger-main-lightbox')?.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('.product-view-tile__image-holder .lightbox')?.click();
    });
}

export default initLightbox;
